export function dateFormat(date, format) {
  let _format = format || 'yyyy-MM-dd';

  const d = date;
  const o = {
    'M+': d.getMonth() + 1, // month
    'd+': d.getDate(), // day
    'h+': d.getHours(), // hour
    'm+': d.getMinutes(), // minute
    's+': d.getSeconds(), // second
    'q+': Math.floor((d.getMonth() + 3) / 3), // quarter
    S: d.getMilliseconds(), // millisecond
  };

  if (/(y+)/.test(_format)) {
    _format = _format.replace(RegExp.$1, (`${d.getFullYear()}`).substr(4 - RegExp.$1.length));
  }

  // eslint-disable-next-line no-restricted-syntax
  for (const k in o) {
    // eslint-disable-next-line no-prototype-builtins
    if (o.hasOwnProperty(k) && new RegExp(`(${k})`).test(_format)) {
      _format = _format.replace(RegExp.$1, RegExp.$1.length === 1 ? o[k] : (`00${o[k]}`).substr((`${o[k]}`).length));
    }
  }

  return _format;
}

export function getLastDayOfMonth(current) {
  let currentMonth = current.getMonth();
  const nextMonth = ++currentMonth;
  const nextMonthDayOne = new Date(current.getFullYear(), nextMonth, 1);
  const minusDate = 1000 * 60 * 60 * 24;
  const lastDay = new Date(nextMonthDayOne.getTime() - minusDate);
  return `${lastDay.getFullYear()}-${lastDay.getMonth() + 1}-${lastDay.getDate()}`;
}

/**
 * 如果url里有debug=1则开启调试模式,引入vconsole便于调试,定位问题
 * @param options {debugTime: 调试时间  }
 * @debugIsOpen 全局调试器状态
 */
export function openDebugger(options) {
  if (options.open == false) {
    return false;
  }
  window.debugTime = options.debugTime ? options.debugTime : 1000;
  if (window.VCONSOLE) {
    return false;
  }
  const bp = document.createElement('script');
  bp.src = '//lyy-public.oss-cn-shenzhen.aliyuncs.com/assets/vendor/vconsole/vConsole.v3.2.0.js';
  const s = document.getElementsByTagName('script')[0];
  s.parentNode.insertBefore(bp, s);
  bp.onload = function (params) {
    /* global VConsole */
    window.VCONSOLE = new VConsole();
    return true;
  };
}

// 去重
export function filterArray(arr) {
  const map = {};
  arr.forEach(v => {
    map[v.value] = v.name;
  });
  const list = Object.entries(map).map(v => ({
    name: v[1],
    value: v[0],
  }));
  return list;
}

// 去掉null
export function filterNull(target) {
  if (Array.isArray(target)) {
    let list = [];
    list = target.map(obj => {
      const map = {};
      Object.keys(obj).forEach(v => {
        const item = obj[v];
        if (!(!item && typeof item === 'object')) {
          map[v] = item;
        }
      });
      return map;
    });
    return list;
  }
  if (Object.prototype.toString.call(target) === '[Object Object]') {
    const map = {};
    Object.keys(target).forEach(v => {
      const item = target[v];
      if (!(!item && typeof item === 'object')) {
        map[v] = item;
      }
    });
    return map;
  }
  return target;
}

// 获取时间范围
export function getDefaultDate(dateType) {
  let start;
  let end;
  const date = new Date();
  switch (dateType) {
  case 'today':
    end = new Date(new Date().toDateString());
    start = new Date();
    start.setTime(end.getTime());
    break;
  case 'yesterday':
    end = new Date(new Date().toDateString());
    start = new Date();
    start.setTime(end.getTime() - 3600 * 1000 * 24);
    end.setTime(end.getTime() - 3600 * 1000 * 24);
    break;
  case 'threeDays':
    end = new Date(new Date().toDateString());
    start = new Date();
    start.setTime(end.getTime() - 3600 * 1000 * 24 * 2);
    break;
  case 'week':
    end = new Date(new Date().toDateString());
    start = new Date();
    start.setTime(end.getTime() - 3600 * 1000 * 24 * 6);
    break;
  case 'twoWeeks':
    end = new Date(new Date().toDateString());
    start = new Date();
    start.setTime(end.getTime() - 3600 * 1000 * 24 * 13);
    break;
  case 'month':
    end = new Date(new Date().toDateString());
    start = new Date();
    start.setTime(end.getTime() - 3600 * 1000 * 24 * 30);
    break;
  case 'along':
    end = new Date(new Date().toDateString());
    start = new Date(new Date('2019/01/01 00:00:00').toDateString());
    break;
  case 'monthFirstDay':
    end = new Date(new Date().toDateString());
    start = new Date();
    start.setDate(1);
    break;
  case 'monthFirstDayYesterday': // 本月的首日和昨日
    end = new Date();
    if (end.getDate() !== 1) {
      end.setTime(end.getTime() - 3600 * 1000 * 24);
    }
    start = new Date();
    start.setDate(1);
    break;
  case 'yesterdayWeek':
    start = new Date();
    start.setDate(start.getDate() - 7);
    end = new Date();
    end.setDate(end.getDate() - 1);
    break;
  case 'monthStartEnd': // 本月的首日和末日
    start = new Date();
    start.setDate(1);
    const maxDay = new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate();
    end = new Date();
    end.setDate(maxDay);
    break;
  case 'fifteenDay':
    start = new Date(new Date().toDateString());
    end = new Date();
    end.setTime(start.getTime() + 3600 * 1000 * 24 * 14);
    break;
  case 'yesterdayThirtydays': // 昨天开始往前30天
    start = new Date();
    start.setDate(start.getDate() - 30);
    end = new Date();
    end.setDate(end.getDate() - 1);
    break;
  case 'yesterdayHalfYear': // 昨天开始往前半年
    start = new Date();
    start.setDate(start.getDate() - 182);
    end = new Date();
    end.setDate(end.getDate() - 1);
    break;
  case 'todayWeek': // 今天开始往前7天
    start = new Date();
    start.setDate(start.getDate() - 6);
    end = new Date();
    break;
  case 'todayThirtydays': // 今天开始往前30天
    start = new Date();
    start.setDate(start.getDate() - 29);
    end = new Date();
    break;
  default:
    break;
  }
  return {
    start: dateFormat(start),
    end: dateFormat(end),
  };
}

// 金钱格式化（三位小数分割, 两位小数点）
export function priceFormat(price, isToFixed) {
  if (isToFixed) {
    return Number(price).toFixed(2).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
  }
  return Number(price).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
}

// 节流函数
export function throttle(func, wait) {
  let previous = 0;
  return function () {
    const now = Date.now();
    const context = this;
    const args = arguments;
    if (now - previous > wait) {
      func.apply(context, args);
      previous = now;
    }
  };
}

export function checkPassword(str) {
  if (!str || str.length < 6 || str.length > 20) {
    return false;
  }
  let num = 0;
  if (/\d/.test(str)) {
    num++;
  }
  if (/[a-z]/.test(str)) {
    num++;
  }
  if (/[A-Z]/.test(str)) {
    num++;
  }
  if (new RegExp("[`~!@#$^&*()=|{}':;',\\[\\].<>《》/?~！@#￥……&*（）——|{}【】‘；：”“'。，、？ ]").test(str)) {
    num++;
  }
  if (num >= 2) {
    return true;
  }
  return false;
}

const $math = require('mathjs');

// 运算精度解决 加法:add 减法:subtract  乘法:multiply  除法:divide
export const math = function (type, num1, num2) {
  if (num1 && num2) {
    return $math.format($math[type]($math.bignumber(num1), $math.bignumber(num2)));
  }
  return 0;
};

export function deepClone(source) {
  if (!source && typeof source !== 'object') {
    throw new Error('error arguments', 'deepClone');
  }
  const targetObj = source.constructor === Array ? [] : {};
  Object.keys(source).forEach(keys => {
    if (source[keys] && typeof source[keys] === 'object') {
      targetObj[keys] = deepClone(source[keys]);
    } else {
      targetObj[keys] = source[keys];
    }
  });
  return targetObj;
}



// WEBPACK FOOTER //
// ./src/utils/index.js